import { render } from "./RateTable.vue?vue&type=template&id=8c90de98&scoped=true"
import script from "./RateTable.vue?vue&type=script&lang=js"
export * from "./RateTable.vue?vue&type=script&lang=js"

import "./RateTable.vue?vue&type=style&index=0&id=8c90de98&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c90de98"]])

export default __exports__